/* gallery-cart.js  real Shopify cart behavior for the Gallery cart design.
   Uses the AJAX Cart API (/cart/change.js, /cart/update.js) + the Section
   Rendering API to re-render in place, the Product Recommendations API for
   cross-sell, and lightweight modals for the trust badges. All hooks are
   data-gly-* so this never collides with the theme's own cart JS. */
(function () {
  'use strict';

  var RECS = [];            // recommendation pool for the cross-sell

  var ROOT_SEL = '[data-section-type="gly-cart"]';
  function root() { return document.querySelector(ROOT_SEL); }
  function sectionId() { var r = root(); return r && r.getAttribute('data-section-id'); }

  /* ---- money formatting via the shop's money_format ---- */
  function formatMoney(cents, format) {
    var value = (cents || 0) / 100;
    function withCommas(s) { return s.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'); }
    function replacer(_, token) {
      switch (token) {
        case 'amount': return withCommas(value.toFixed(2));
        case 'amount_no_decimals': return withCommas(value.toFixed(0));
        case 'amount_with_comma_separator': return value.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!,))/g, '$1.');
        case 'amount_no_decimals_with_comma_separator': return withCommas(value.toFixed(0));
        default: return withCommas(value.toFixed(2));
      }
    }
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, replacer);
  }

  /* ---- section re-render (keeps every Liquid value server-accurate) ---- */
  function rerender() {
    var id = sectionId();
    if (!id) return Promise.resolve();
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(id);
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(ROOT_SEL);
        var current = root();
        if (fresh && current) { current.replaceWith(fresh); afterRender(); }
      });
  }

  /* Brief loading spinner shown over the cart while a change is in flight.
     Appended into the current root; the section re-render replaces root and
     removes it, with an explicit cleanup as a fallback. */
  function showSpinner() {
    var r = root();
    if (!r) return null;
    var ov = document.createElement('div');
    ov.className = 'gly-spin-overlay';
    ov.innerHTML = '<div class="gly-spin" role="status" aria-label="Updating"></div>';
    r.appendChild(ov);
    return ov;
  }
  /* Show Shopify's "you can only add N" message on a line when the stock cap is hit. */
  function showLineLimit(key, msg) {
    var r = root(); if (!r) return;
    var sel = window.CSS && CSS.escape ? CSS.escape(key) : key.replace(/"/g, '\\"');
    var line = r.querySelector('[data-key="' + sel + '"]');
    var el = line && line.querySelector('[data-gly-limit]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 4500);
  }
  function changeLine(key, quantity) {
    var ov = showSpinner();
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) { return res.json().then(function (err) { throw err; }); }
        return res.json();
      })
      .then(function (cart) {
        updateHeaderCount(cart.item_count); // the header cart badge is outside the cart section, so update it too
        return rerender();
      })
      .catch(function (err) {
        if (err && (err.description || err.message)) showLineLimit(key, err.description || err.message);
      })
      .then(function () { if (ov && ov.parentNode) ov.parentNode.removeChild(ov); });
  }
  /* The header cart count lives in the header section, not the cart section, so a
     cart-section re-render won't touch it — sync it explicitly on every change. */
  function updateHeaderCount(n) {
    if (n == null) return;
    document.querySelectorAll('[data-js-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('hide', Number(n) === 0);
    });
  }
  function updateNote(note) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note })
    });
  }
  function lineKey(el) { var l = el.closest('[data-key]'); return l && l.getAttribute('data-key'); }
  function lineQty(el) { var l = el.closest('[data-key]'); var i = l && l.querySelector('[data-gly-input]'); return i ? parseInt(i.value, 10) || 0 : 0; }

  /* ---- swappable social proof (real source wired later) ---- */
  function hydrateSocialProof() {
    if (typeof window.GLYSocialProof !== 'function') return;
    document.querySelectorAll('[data-gly-social]').forEach(function (el) {
      try {
        Promise.resolve(window.GLYSocialProof(el.getAttribute('data-product-id'))).then(function (text) {
          if (text) { el.textContent = text; el.hidden = false; }
        });
      } catch (e) {}
    });
  }

  /* ---- Shopify product recommendations (also feeds the free-ship modal) ---- */
  function imgUrl(u, w) {
    if (!u) return '';
    var s = String(u);
    if (s.indexOf('//') === 0) s = 'https:' + s;
    return s + (s.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 400);
  }
  function recCardHtml(p, fmt) {
    var img = imgUrl(p.featured_image, 400);
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    return '<div class="xc">' +
      '<a class="xc__img" href="' + p.url + '">' + (img ? '<img src="' + img + '" loading="lazy" alt="' + escapeAttr(p.title) + '">' : '') + '</a>' +
      '<a class="xc__name" href="' + p.url + '">' + escapeHtml(p.title) + '</a>' +
      '<div class="xc__meta"><span class="xc__price' + (onSale ? '' : ' is-plain') + '">' + formatMoney(p.price, fmt) + '</span>' +
      (onSale ? '<span class="xc__was">' + formatMoney(p.compare_at_price, fmt) + '</span>' : '') +
      '</div>' +
      '<button type="button" class="xc__qv" data-gly-qv data-handle="' + escapeAttr(p.handle || '') + '">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>' +
      'Quick view</button>' +
      '</div>';
  }
  function loadRecommendations() {
    var r = root(); if (!r) return;
    var el = r.querySelector('[data-gly-recs]');
    var pid = (el && el.getAttribute('data-product-id')) || r.getAttribute('data-first-product');
    if (!pid) return;
    var fmt = r.getAttribute('data-money-format') || '${{amount}}';
    var displayLimit = el ? (parseInt(el.getAttribute('data-limit'), 10) || 8) : 8;
    var poolLimit = Math.max(displayLimit, 12);
    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=' + poolLimit + '&intent=related')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        RECS = (data && data.products) || [];
        if (el && RECS.length) {
          var grid = el.querySelector('[data-gly-recs-grid]');
          if (grid) { grid.innerHTML = RECS.slice(0, displayLimit).map(function (p) { return recCardHtml(p, fmt); }).join(''); el.hidden = false; }
        }
      })
      .catch(function () {});
  }
  function escapeHtml(s) { return String(s).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }); }
  function escapeAttr(s) { return escapeHtml(s).replace(/"/g, '&quot;'); }

  /* ---- modals ---- */
  function openModal(key) {
    var panel = document.querySelector('[data-gly-modal-panel="' + key + '"]');
    if (!panel) return;
    panel.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeModals() {
    document.querySelectorAll('[data-gly-modal-panel]').forEach(function (p) { p.hidden = true; });
    document.body.style.overflow = '';
  }

  function afterRender() {
    hydrateSocialProof();
    loadRecommendations();
  }

  /* ---- delegated events (survive re-render) ---- */
  document.addEventListener('click', function (e) {
    var modalOpen = e.target.closest('[data-gly-modal]');
    var modalClose = e.target.closest('[data-gly-modal-close]');
    if (modalClose) { e.preventDefault(); closeModals(); return; }
    if (modalOpen) { e.preventDefault(); openModal(modalOpen.getAttribute('data-gly-modal')); return; }

    if (!root() || !root().contains(e.target)) return;

    var inc = e.target.closest('[data-gly-inc]');
    var dec = e.target.closest('[data-gly-dec]');
    var rem = e.target.closest('[data-gly-remove]');
    var promoToggle = e.target.closest('[data-gly-promo-toggle]');
    var promoApply = e.target.closest('[data-gly-promo-apply]');
    var giftToggle = e.target.closest('[data-gly-gift-toggle]');

    if (inc) { e.preventDefault(); var k = lineKey(inc); if (k) changeLine(k, lineQty(inc) + 1); return; }
    if (dec) { e.preventDefault(); var k2 = lineKey(dec); if (k2) changeLine(k2, Math.max(0, lineQty(dec) - 1)); return; }
    if (rem) { e.preventDefault(); var k3 = lineKey(rem); if (k3) changeLine(k3, 0); return; }

    if (promoToggle) { e.preventDefault(); var box = root().querySelector('[data-gly-promo]'); if (box) box.hidden = !box.hidden; return; }
    if (promoApply) { e.preventDefault(); applyPromo(); return; }

    if (giftToggle) {
      var check = root().querySelector('[data-gly-gift-check]');
      var note = root().querySelector('[data-gly-gift-note]');
      if (check && note) {
        var on = !check.classList.contains('on');
        check.classList.toggle('on', on);
        note.hidden = !on;
        if (on) note.focus();
      }
      return;
    }
  });

  function applyPromo() {
    var input = root().querySelector('[data-gly-promo-input]');
    var code = input && input.value.trim();
    if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  }

  /* Enter key applies the promo code. */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeModals(); return; }
    if (e.key === 'Enter' && e.target.closest && e.target.closest('[data-gly-promo-input]')) {
      e.preventDefault();
      applyPromo();
    }
  });

  /* Persist the gift note to the cart. */
  document.addEventListener('change', function (e) {
    var note = e.target.closest('[data-gly-gift-note]');
    if (note) updateNote(note.value);
  });

  /* Quick view is provided by the shared gallery-quickview.js (window.GLYQuickView).
     Recommendation cards carry [data-gly-qv][data-handle]; refresh the cart after a
     quick-add so the totals/lines update. */
  document.addEventListener('gly-qv:added', function () { rerender(); });

  if (document.readyState !== 'loading') afterRender();
  else document.addEventListener('DOMContentLoaded', afterRender);
})();
